/** Seconds the thank-you page counts down before a consultant's call, matching the homepage. */
export const CALL_COUNTDOWN_SECONDS = 60;

/**
 * Whole seconds left in the countdown. Derived from the start time rather than counting
 * ticks, so a throttled background tab still shows the right number when it wakes.
 */
export function callSecondsRemaining(startedAt: number, now: number): number {
  return Math.max(0, CALL_COUNTDOWN_SECONDS - Math.floor((now - startedAt) / 1_000));
}
